export default "__VITE_ASSET__B2Fbs9Sp__"